import { render, staticRenderFns } from "./CourseWise.vue?vue&type=template&id=50d3cc68&scoped=true"
import script from "./CourseWise.vue?vue&type=script&lang=js"
export * from "./CourseWise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d3cc68",
  null
  
)

export default component.exports